<app-page-header
  eyebrow="Дуел на пазарите"
  title="Сравнение на градове"
  lead="Избери от 2 до 4 града и ги постави рамо до рамо — цени, наеми, доходност, достъпност и здраве на пазара."
>
  <app-granularity-toggle [value]="granularity()" (change)="granularity.set($event)" />
</app-page-header>

<app-market-notice />

@if (meta(); as m) {
  <div class="pickers card">
    @for (c of m.cities; track c.id) {
      <label class="pick" [class.disabled]="!isSelected(c.slug) && selected().length >= 4">
        <input
          type="checkbox"
          [checked]="isSelected(c.slug)"
          [disabled]="!isSelected(c.slug) && selected().length >= 4"
          (change)="toggleCity(c.slug)"
        />
        {{ c.name }}
      </label>
    }
  </div>
}

@if (details(); as list) {
  @if (list.length >= 2) {
    <div class="grid cols-2 charts-row">
      <div class="card">
        <h3>Медиана офертна €/м² (продажба)</h3>
        <app-trend-chart [data]="priceSeries()" unit="€/м²" [height]="320" />
      </div>
      <div class="card">
        <h3>Медиана наем €/м²/мес</h3>
        <app-trend-chart [data]="rentSeries()" unit="€/м²" [height]="320" />
      </div>
    </div>
    <div class="grid cols-2 charts-row">
      <div class="card">
        <h3>Достъпност (години доход)</h3>
        <app-trend-chart [data]="affordabilitySeries()" unit="год." [height]="280" />
      </div>
      <div class="card">
        <h3>Дял намалени обяви (%)</h3>
        <app-trend-chart [data]="cutSeries()" unit="%" [height]="280" />
      </div>
    </div>

    <h2>Ключови показатели</h2>
    <div class="table-wrap">
      <table class="data-table">
        <thead>
          <tr>
            <th>Показател</th>
            @for (d of list; track d.city.id) {
              <th class="num">
                <a [routerLink]="['/grad', d.city.slug]" class="city-col-link" title="Към профила на {{ d.city.name }}">
                  {{ d.city.name }} ↗
                </a>
              </th>
            }
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Медиана офертна €/м²</td>
            @for (d of list; track d.city.id) {
              <td class="num strong" [class.highlight-best]="minPrice(list) !== null && d.price.headline === minPrice(list)">
                {{ d.price.headline | eurM2 }}
                @if (minPrice(list) !== null && d.price.headline === minPrice(list) && list.length > 2) {
                  <span class="best-badge">най-ниска</span>
                }
              </td>
            }
          </tr>
          <tr>
            <td>Ръст ГоГ</td>
            @for (d of list; track d.city.id) {
              <td class="num" [class.highlight-best]="maxGrowth(list) !== null && d.price.yoyPct === maxGrowth(list)">
                {{ d.price.yoyPct | pct }}
              </td>
            }
          </tr>
          <tr>
            <td>Наем €/м²/мес</td>
            @for (d of list; track d.city.id) {
              <td class="num">{{ d.rent.headline | bg2 }} €</td>
            }
          </tr>
          <tr>
            <td>Брутна доходност</td>
            @for (d of list; track d.city.id) {
              <td class="num" [class.highlight-best]="maxYield(list) !== null && d.rentalYield.headline === maxYield(list)">
                {{ d.rentalYield.headline | bg2 }} %
                @if (maxYield(list) !== null && d.rentalYield.headline === maxYield(list) && list.length > 2) {
                  <span class="best-badge">лидер</span>
                }
              </td>
            }
          </tr>
          <tr>
            <td>Достъпност (год. доход)</td>
            @for (d of list; track d.city.id) {
              <td class="num">{{ d.affordability.headline | bg1 }}</td>
            }
          </tr>
          <tr>
            <td>Активни обяви</td>
            @for (d of list; track d.city.id) {
              <td class="num">{{ d.inventory.headline | bgInt }}</td>
            }
          </tr>
          <tr>
            <td>Дни на пазара</td>
            @for (d of list; track d.city.id) {
              <td class="num">{{ d.domDays | bgInt }}</td>
            }
          </tr>
          <tr>
            <td>Месеци до изчерпване</td>
            @for (d of list; track d.city.id) {
              <td class="num">{{ d.absorptionMonths | bg1 }}</td>
            }
          </tr>
          <tr>
            <td>Индекс на прегряване</td>
            @for (d of list; track d.city.id) {
              <td class="num">
                <span
                  [class.hot]="d.overheating.score !== null && d.overheating.score > 65"
                  [class.cool]="d.overheating.score !== null && d.overheating.score < 40"
                >
                  {{ d.overheating.score ?? '—' }}
                </span>
              </td>
            }
          </tr>
          <tr>
            <td>Градиент от центъра</td>
            @for (d of list; track d.city.id) {
              <td class="num">{{ d.centerGradient.decayPctPerKm | bg1 }} %/км</td>
            }
          </tr>
        </tbody>
      </table>
    </div>
  } @else {
    <p class="hint">Избери поне два града за сравнение.</p>
  }
} @else {
  <p class="loading">Зареждане…</p>
}
